module.exports = __webpack_public_path__ + "static/media/green-check-big.f2e2e019.svg";